import { useState } from "react";



export default function Checkbox(props)  {

    const min = 1;
    const max = 4;
    // if(props.mycount>2){
    //      props.SetRandCheck(props.CheckRand+1);
    // }

    const handleOnChange = () => {
      for (let i = 0; i < props.Allcheck.length; i++) {
        props.Allcheck[i] = false;
      }
      props.Allcheck[props.index] = true;

        let   ArrayCopy =  [...props.Allcheck];
            props.setChecked(ArrayCopy);
    }

   return (
         <div className={props.Allcheck[props.index] ? "checkbox-style checked" : "checkbox-style"}>
             <div className = "topping-all" >

                 <input 
                    className="radio-style"
                    type="radio"
                    id="topping-inside"
                    name= "topping"
                    value = {props.Allcheck[props.index]}
                    onChange={handleOnChange}
                 />
                 {props.name}
            </div>
         </div>
     )
};